import React from 'react'

const NoMatch = () => {
    return <h1>This page not found</h1>
}

export default NoMatch
